import { FC, memo, useCallback } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { PressableScale } from "pressto";
import { Icon } from "@src/components/Icon";

type NumericButtonProps = {
  value: number | string;
  onPress: (value: number) => void;
  onDelete: () => void;
  enabled?: boolean;
};

const ButtonWidth = 90;
const ButtonHeight = 56;

export const NumericButton: FC<NumericButtonProps> = memo(({ value, onPress, onDelete, enabled }) => {
  const isDelete = value === "delete";
  const isEmpty = value === "";
  const { theme } = useUnistyles();
  const onPressNumericButton = useCallback(() => {
    if (typeof value === "number") {
      return onPress(value);
    }
    return onDelete();
  }, [value, onPress, onDelete]);

  if (isEmpty) return <View style={styles.emptyButton} />;

  return (
    <PressableScale key={value} onPress={onPressNumericButton} style={styles.keyButton} enabled={enabled}>
      {isDelete ?
        <Icon name="arrowLeft" color={theme.colors.interactive.buttons.default_foreground} />
      : <Text textStyle="h3/regular" style={{ color: theme.colors.interactive.buttons.default_foreground }}>
          {value}
        </Text>
      }
    </PressableScale>
  );
});

const styles = StyleSheet.create((theme) => ({
  keyButton: {
    width: ButtonWidth,
    height: ButtonHeight,
    borderRadius: theme.spacing.md,
    backgroundColor: "transparent",
    borderWidth: 1.5,
    borderColor: theme.colors.surface1.foregroundSecondary,
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.xl,
  },
  emptyButton: {
    width: ButtonWidth,
    height: ButtonHeight,
  },
}));
